<template>
    <div>
        <breadcrumb :routerList="[{to:'/abnormal/applyList',title:'异常数据申请列表'},{title: pageTitle}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <!--基本信息-->
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine Yangbiao">
                                        <el-form :model="form" :rules="rules" ref="form" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="单号" class="h-elformWrap-35">
                                                <el-input
                                                    v-if="isAdd"
                                                    disabled
                                                    placeholder="提交后自动生成">
                                                </el-input>
                                                <el-input
                                                    v-else
                                                    v-model="form.applyno"
                                                    readonly
                                                    disabled>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="业务模块" class="h-elformWrap-35" prop="businessModule">
                                                <brselect
                                                    :v="form.businessModule"
                                                    v-model="form.businessModule"
                                                    category="abnormal_business_module"
                                                    :disabled="isView"
                                                    placeholder="请选择业务模块">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="状态" class="h-elformWrap-35" v-if="!isAdd">
                                                <el-input :value="getStatusName(form.status)" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="申请人" class="h-elformWrap-35" v-if="!isAdd">
                                                <el-input v-model="form.cuname" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建时间" class="h-elformWrap-35" v-if="!isAdd">
                                                <el-input :value="formatDate(form.cdate)" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="问题说明" class="h-elformWrap-1" prop="problemDesc">
                                                <el-input
                                                    type="textarea"
                                                    v-model="form.problemDesc"
                                                    :rows="3"
                                                    :disabled="isView"
                                                    placeholder="请描述异常现象"
                                                    style="border: #dedede 1px solid;">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="期望修改内容" class="h-elformWrap-1" prop="expectContent">
                                                <el-input
                                                    type="textarea"
                                                    v-model="form.expectContent"
                                                    :rows="3"
                                                    :disabled="isView"
                                                    placeholder="请描述期望修改的内容"
                                                    style="border: #dedede 1px solid;">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="申请附件" class="h-elformWrap-1" v-if="!isAdd">
                                                <brupload
                                                    :refid="form.id"
                                                    reftype="abnormal_apply"
                                                    :uploadflag="isAdd || isEdit"
                                                    :delflag="isAdd || isEdit">
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="申请附件（选填）" class="h-elformWrap-1" v-if="isAdd">
                                                <brupload
                                                    refid=""
                                                    reftype="abnormal_apply"
                                                    :uploadflag="true"
                                                    :delflag="true"
                                                    @filecallback="handleFileCallback">
                                                </brupload>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>

                            <!--运维信息（查看模式显示）-->
                            <div class="h-pieceIn2" v-if="isView">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>运维信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine Yangbiao">
                                        <el-form :model="ywForm" :rules="ywRules" ref="ywForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="问题类型" class="h-elformWrap-35" prop="problemType">
                                                <brselect
                                                    :v="ywForm.problemType"
                                                    v-model="ywForm.problemType"
                                                    category="abnormal_problem_type"
                                                    disabled
                                                    placeholder="请选择问题类型">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="接收时间" class="h-elformWrap-35" v-if="form.receiveTime">
                                                <el-input :value="formatDate(form.receiveTime)" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="解决方案" class="h-elformWrap-1" v-if="isView && form.solution" prop="solution">
                                                <el-input
                                                    type="textarea"
                                                    v-model="ywForm.solution"
                                                    :rows="3"
                                                    disabled
                                                    placeholder="请填写解决方案"
                                                    style="border: #dedede 1px solid;">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="完成时间" class="h-elformWrap-35" v-if="isView && form.completeTime">
                                                <el-input :value="formatDate(form.completeTime)" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="运维处理人" class="h-elformWrap-35" v-if="isView && form.ywHandlerName">
                                                <el-input v-model="form.ywHandlerName" readonly disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="解决附件" class="h-elformWrap-1" v-if="isView && solveFiles.length > 0">
                                                <brupload
                                                    :refid="form.id"
                                                    reftype="abnormal_solve"
                                                    :uploadflag="false"
                                                    :delflag="false">
                                                </brupload>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <viewhistory :visible.sync="showTrackDialog" v-if="showTrackDialog" :id="form.instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="handleBack">返回</el-button>
                <el-button v-if="isAdd || isEdit" class="h-btn h-bBtn h-bggreen" @click="handleSave">保存草稿</el-button>
                <el-button v-if="isAdd || isEdit" class="h-btn h-bBtn h-bgblueQ2" @click="handleSubmit">提交申请</el-button>
                <el-button v-if="isResubmit" class="h-btn h-bBtn h-bgblueQ2" @click="handleResubmit">重新提交</el-button>
                <el-button v-if="!isAdd" class="el-button h-btn el-button--default" @click="handleTrack">审批跟踪</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import ApplyService from '@/api/abnormal/ApplyService';

export default {
    data() {
        return {
            form: {
                id: '',
                applyno: '',
                problemDesc: '',
                businessModule: '',
                expectContent: '',
                status: '',
                instid: '',
                cuname: '',
                cdate: '',
                receiveTime: '',
                completeTime: '',
                ywHandlerName: ''
            },
            ywForm: {
                problemType: '',
                solution: ''
            },
            applyFiles: [],
            solveFiles: [],
            fileIds: [],
            showTrackDialog: false,
            statusMap: {
                0: '草稿',
                1: '待IT接口人审批',
                2: '待运维处理',
                3: '处理中',
                4: '已完成',
                5: '已驳回'
            },
            rules: {
                problemDesc: [{ required: true, message: '请输入问题说明', trigger: 'blur' }],
                businessModule: [{ required: true, message: '请选择业务模块', trigger: 'change' }],
                expectContent: [{ required: true, message: '请输入期望修改内容', trigger: 'blur' }]
            },
            ywRules: {
                problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }]
            }
        };
    },
    computed: {
        mode() {
            return this.$route.query.mode || 'view';
        },
        isAdd() {
            return this.mode === 'add';
        },
        isEdit() {
            return this.mode === 'edit';
        },
        isResubmit() {
            return this.mode === 'resubmit';
        },
        isView() {
            return this.mode === 'view';
        },
        pageTitle() {
            if (this.isAdd) return '新建异常数据申请';
            if (this.isEdit) return '编辑异常数据申请';
            if (this.isResubmit) return '重新提交异常数据申请';
            return '异常数据申请详情';
        }
    },
    created() {
        const id = this.$route.query.id;
        if (id) {
            this.loadDetail(id);
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.getFullYear() + '-' +
                String(d.getMonth() + 1).padStart(2, '0') + '-' +
                String(d.getDate()).padStart(2, '0') + ' ' +
                String(d.getHours()).padStart(2, '0') + ':' +
                String(d.getMinutes()).padStart(2, '0') + ':' +
                String(d.getSeconds()).padStart(2, '0');
        },
        getStatusName(status) {
            return this.statusMap[status] || '';
        },
        async loadDetail(id) {
            try {
                const res = await ApplyService.detail(id);
                if (res.f && res.obj) {
                    const data = res.obj;
                    this.form = data.apply || {};
                    this.applyFiles = data.applyFiles || [];
                    this.solveFiles = data.solveFiles || [];
                    this.ywForm.problemType = this.form.problemType || '';
                    this.ywForm.solution = this.form.solution || '';
                }
            } catch (e) {
                console.error(e);
            }
        },
        handleFileCallback(files) {
            this.fileIds = files.map(f => f.id);
        },
        async handleSave() {
            try {
                await this.$refs.form.validate();
                const data = {
                    ...this.form,
                    fileIds: this.fileIds
                };
                const res = await ApplyService.save(data);
                if (res.f) {
                    this.$message.success(res.msg || '保存成功');
                    this.$router.push('/abnormal/applyList');
                } else {
                    this.$message.error(res.msg || '保存失败');
                }
            } catch (e) {
                console.error(e);
            }
        },
        async handleSubmit() {
            try {
                await this.$refs.form.validate();
                const data = {
                    ...this.form,
                    fileIds: this.fileIds
                };
                const res = await ApplyService.submit(data);
                if (res.f) {
                    this.$message.success(res.msg || '提交成功');
                    this.$router.push('/abnormal/applyList');
                } else {
                    this.$message.error(res.msg || '提交失败');
                }
            } catch (e) {
                console.error(e);
            }
        },
        handleBack() {
            this.$router.push('/abnormal/applyList');
        },
        handleTrack() {
            this.showTrackDialog = true;
        },
        async handleResubmit() {
            try {
                await this.$refs.form.validate();
                const data = {
                    ...this.form,
                    fileIds: this.fileIds
                };
                const res = await ApplyService.resubmit(data);
                if (res.f) {
                    this.$message.success(res.msg || '重新提交成功');
                    this.$router.push('/abnormal/applyList');
                } else {
                    this.$message.error(res.msg || '重新提交失败');
                }
            } catch (e) {
                console.error(e);
            }
        }
    }
};
</script>
<style>
.Yangbiao .h-elformWrap-2 .el-form-item__label {
    width: 45%;
    text-align: right;
}

.Yangbiao .el-form-item__content {
    width: 55%;
}

.Yangbiao .h-elformWrap-2 {
    width: 25% !important;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-5 {
    width: 74% !important;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 {
    width: 85% !important;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 .el-form-item__label {
    width: 12%;
    text-align: right;
}

.Yangbiao .h-elformWrap-35 {
    width: 33.333% !important;
}

.Yangbiao .h-elformWrap-35 .el-form-item__label {
    width: 35%;
    text-align: right;
}

.Yangbiao .h-elformWrap-35 .el-form-item__content {
    width: 65%;
}

.Yangbiao .h-elformWrap-4 {
    width: 100%;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-4 .el-form-item__label {
    width: 10%;
}

.Yangbiao .h-elformWrap-4 .el-form-item__content {
    width: 89%;
}

.Yangbiao .w-elformWrap {
    width: 100% !important;
}

.w-elformWrap .el-form-item__label {
    width: 14% !important;
}

.w-elformWrap .el-form-item__content {
    width: 86% !important;
}

.Yangbiao .h-elformWrap-1 {
    width: 100%;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-1 .el-form-item__label {
    width: 14%;
}

.Yangbiao .h-elformWrap-1 .el-form-item__content {
    width: 86%;
}

.Yangbiao.el-form-item__content .el-select {
    width: 100%;
}
</style>
